<template>
  <div class="fullpage">
    <div class="section section4">
      <a href="http://gw.dzcce.com/#/" target="_blank" class="btn-dzjk">
        <el-image :src="require('../assets/images/btn_dzjk.png')" alt=""></el-image>
      </a>

      <div class="bgbox">
        <el-image :src="bgImg" class="bgImg">
          <el-image slot="error" :src="require('../assets/images/map_bg.jpg')"></el-image>
        </el-image>
      </div>
      <div class="logins">
        <el-row :gutter="10" style="width: 100%">
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
            <div class="login" @click="openDialog(1)">
              <el-image :src="require('../assets/images/dl_an_1.png')" alt/>
              <p>
                教育局管理
                <br/>登录入口
              </p>
            </div>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
            <div class="login login2" @click="openDialog(2)">
              <el-image :src="require('../assets/images/dl_an_2.png')" alt/>
              <p>
                <!-- 疾病预防控制中心 -->
                卫健委管理
                <br/>登录入口
              </p>
            </div>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
            <div class="login login3" @click="openDialog(3)">
              <el-image :src="require('../assets/images/dl_an_3.png')" alt/>
              <p>
                <!-- 各幼儿园 -->
                幼儿园管理
                <br/>登录入口
              </p>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="sec4_footer">
        <div class="footer_btn1">
          <a href="javascript:;" class="code_xcx">云呵护小程序</a>
          <img class="img1" src="../assets/images/footer_btn1_ewm.png" alt/>
          <!-- <a href="javascript:;" class="code_app">云呵护APP下载</a>
          <img class="img2" src="../assets/images/footer_btn2_app.png" alt /> -->
        </div>
        <div class="copyRight">
          <p>版权所有 : 大知（上海）健康科技有限公司</p>
          <a href="https://beian.miit.gov.cn/" target="_blank"
          >ICP备案号 沪ICP备13010097号-5</a
          >
        </div>
      </div>
    </div>

    <LoginDialog :detailsDialog="detailsDialog"></LoginDialog>
    <ResetPwd :resetDialog="resetDialog"></ResetPwd>
  </div>
</template>
<script>
import qs from "qs";
import LoginDialog from "./LoginDialog";
import ResetPwd from "./ResetPwd";
import Loading from "element-ui";

export default {
  name: "login",
  components: {LoginDialog, ResetPwd},
  data() {
    return {
      loginType: 1,
      detailsDialog: false,
      resetDialog: false,
      styleObj: {},
      login_jyj: "",
      login_wjw: "",
      sjfxPage: "", //数据分析页
      sjfxJump: "", //_self _blank,
      bgImg: "",
    };
  },
  mounted() {
    this.isLogin();
    this.getConfig();
  },
  methods: {
    getConfig() {
      const load = this.$loading({text: "正在获取配置文件..."});
      let map;
      if (this.$positionName == "sh") {
        map = {Region: 2};
      } else {
        map = {Region: 1};
      }
      this.axios
        .post("api/user/GetConfig", qs.stringify(map))
        .then((res) => {
          let data = res.data;
          if (data.resultType == 0) {
            var config = data.appendData;
            document.title = this._filter(config, "yyt.title");
            this.bgImg = this._filter(config, "yyt.image");
            this.styleObj = {
              background: "url(" + this._filter(config, "yyt.image") + ")",
              backgroundSize: " 100% 100%",
            };
            this.login_jyj = this._filter(config, "yyt.img_login_jyj");
            this.login_wjw = this._filter(config, "yyt.dl_dl_pic2");
            if (this.$positionName == "wz") {
              this.sjfxPage = this._filter(config, "yyt.sjfx");
              this.sjfxJump = this._filter(config, "yyt.sjfx_jump");
              localStorage.setItem("sjfxPage", this.sjfxPage);
              localStorage.setItem("sjfxJump", this.sjfxJump);
            }
          } else {
            this.$alert("配置文件获取失败,请重试!");
          }
          load.close();
        })
        .catch((err) => {
          load.close();
          console.log(err);
          this.$alert("请求失败处理");
        });
    },
    _filter(datas, key) {
      return datas.filter((x) => x.keys == key)[0].vals;
    },
    isLogin() {
      let token = localStorage.getItem("loginToken");
      let timestamp = new Date().getTime();
      let expires = localStorage.getItem("tokenExpires") || 0;
      if (token && expires > timestamp) {
        this.loginSuccess();
      }
    },
    loginSuccess() {
      localStorage.removeItem("classData");
      localStorage.removeItem("schoolDevice");
      localStorage.removeItem("semesterData");
      localStorage.removeItem("symptomData");
      localStorage.removeItem("foodAndDish");
      localStorage.removeItem("placeData");
      if (this.loginType != 3) {
        if (this.sjfxJump == "_self") {
          this.axios
            .post("api/user/GetAdminInfo")
            .then((res) => {
              if (res.data.resultType == 0) {
                this.admin = res.data.appendData;
                localStorage.setItem("userInfo", this.admin);

                localStorage.setItem("admindid", this.admin.districtId);
                localStorage.setItem("admindname", this.admin.cityName);
                this.$store.commit("setUser", this.admin);
                this.$router.push("/homepage");
              } else if (res.data.resultType == 401) {
                this.$alert(res.data.message);
                localStorage.clear();
                this.$router.push("/login");
              }
            })
            .catch((err) => {
              this.$alert(err);
            });
        } else if (this.sjfxJump == "_blank") {
          location.href = this.sjfxPage + url;
        }
        // this.getDistrictId();
      } else {
        let redirect = this.$route.query.redirect;
        if (redirect) {
          if (redirect == "/homepage") this.$router.push("/datas");
          else this.$router.push(redirect);
        } else {
          this.$router.push("/home");
        }
      }
    },
    getDistrictId() {
      this.axios
        .post("api/user/GetDistrictId")
        .then((res) => {
          let data = res.data;
          if (data.resultType == 0) {
            let districtId = data.appendData;
            localStorage.setItem("districtId", districtId);
            this.jumpPage(districtId);
          } else {
            this.$alert(data.message);
          }
        })
        .catch((err) => {
          this.$alert("请求失败处理");
        });
    },
    jumpPage(did) {
      if (did == 0) {
        this.$router.push({path: "/homepage"});
      } else {
        var url = `/district.html?did=${did}&ts=${new Date().getTime()}`;
        if (this.sjfxJump == "_self") {
          localStorage.setItem("jumpUrl", url);
          // this.$router.push("/homepage");
          this.$router.push({
            path: "/homepage",
            query: {url: url},
          });
        } else if (this.sjfxJump == "_blank") {
          location.href = this.sjfxPage + url;
        }
      }
    },

    openDialog(type) {
      this.loginType = type;
      this.detailsDialog = true;
    },
    closeDialog() {
      this.detailsDialog = false;
    },
    resetClose() {
      this.resetDialog = false;
    },
  },
};
</script>
<style scoped>
@import "../assets/css/login.css";
</style>

<style lang="less">
#app,
.fullpage {
  height: 100%;
}

// .fullpage {
//   filter: grayscale(1);
// }

.btn-dzjk {
  position: fixed;
  right: 15px;
  top: 15px;
  z-index: 3;
}

.bgbox {
  text-align: center;
  width: 60%;
  max-width: 1109px;
  //min-height: calc(100vh - 300px);
  margin: 0 auto 30px;

  .bgImg {
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Login.vue